/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_New_No_PermissionInputs */



/**
* | output |
* | --- |
* | "Only IC, NC, or Prince can create tournaments." |
*
* @param {Tournament_New_No_PermissionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_new_no_permission = /** @type {((inputs?: Tournament_New_No_PermissionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_New_No_PermissionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuls les IC, NC ou Prince peuvent créer des tournois.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo IC, NC o Prince pueden crear torneos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Apenas IC, NC, ou Prince podem criar torneios.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo IC, NC, o Prince possono creare tornei.")
	return /** @type {LocalizedString} */ ("Only IC, NC, or Prince can create tournaments.")
});